import { APIScope } from "../API/APIScope.Interfaces";
import { AgentInterface } from "../Agent/Agent.Interface";
import { MessageAuth } from "../Com/Com.Interfaces";
import { Conversation } from "../Conversations/Conversations.Interface";
import { EscalationInterface } from "../Escalations/Escalations.Interface";
import { MessageInterface } from "../Message/Message.Interface";
import { SessionInterface } from "../Sessions/Sessions.Interface";
import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { UserInterface } from "../User/User.Interface";
import { VarKey } from "../Variables/Generated/VarKey.Data";

export enum NotificationType {
  TOAST = "toast",
  ESCALATION = "escalation",
}

export type NotificationInterface = ToastNotificationInterface | EscalationAssignedNotificationInterface;

export interface NotificationBaseInterface extends OrgBaseInterface {
  id: number;
  type: NotificationType;
  memberId: number;

  userId?: number;
  locationId?: number; // This corresponds to the location where the notification is relevant.
  escalationId?: number;
  acknowledged: boolean;
  acknowledgedAt?: Date;
  data?: any;
  user?: UserInterface; // Optional, if the notification is related to a user.
  escalation?: EscalationInterface;
}
export interface EscalationAssignedNotificationInterface extends NotificationBaseInterface {
  type: NotificationType.ESCALATION;
  userId: number;

  user: UserInterface; // Optional, if the notification is related to a user.
  escalationId: number;

  escalation: EscalationInterface; // Optional, if the notification is related to an escalation.
}

export interface ToastNotificationInterface extends NotificationBaseInterface {
  type: NotificationType.TOAST;
}
